import { createContext, ReactNode, useEffect, useState } from 'react';
import { ICategories } from '../../Components/Cadastro/Categorias/interface/ICategories';
import api from '../../Services/api';
import globals from '../../Globals.json';
import { toast } from 'react-toastify';

interface ChildrenProps {
  children: ReactNode;
}

interface InitialContextInterface {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  xdFollowItem: boolean;
  setXdFollowItem: React.Dispatch<React.SetStateAction<boolean>>;
  selfService: boolean;
  setSelfService: React.Dispatch<React.SetStateAction<boolean>>;
  visible_falimix: boolean;
  setVisible_falimix: React.Dispatch<React.SetStateAction<boolean>>;
  visible_autoplu: boolean;
  setVisible_autoplu: React.Dispatch<React.SetStateAction<boolean>>;
  visible_delivery: boolean;
  setVisible_delivery: React.Dispatch<React.SetStateAction<boolean>>;
  visible_xd_orders: boolean;
  setVisible_xd_orders: React.Dispatch<React.SetStateAction<boolean>>;
  visible_online: boolean;
  setVisible_online: React.Dispatch<React.SetStateAction<boolean>>;
  visible_digital_menu: boolean;
  setVisible_digital_menu: React.Dispatch<React.SetStateAction<boolean>>;
  xdPrinters: string;
  xdRequestQty: boolean;
  setXdRequestQty: React.Dispatch<React.SetStateAction<boolean>>;
  xdRequestPriceWhenZero: boolean;
  setXdRequestPriceWhenZero: React.Dispatch<React.SetStateAction<boolean>>;
  xdBalanceQty: boolean;
  setXdBalanceQty: React.Dispatch<React.SetStateAction<boolean>>;
  xdOrderGrouped: boolean;
  setXdOrderGrouped: React.Dispatch<React.SetStateAction<boolean>>;
  xdBillGroup: boolean;
  setXdBillGroup: React.Dispatch<React.SetStateAction<boolean>>;
  xdAddTips: boolean;
  setXdAddTips: React.Dispatch<React.SetStateAction<boolean>>;
  xdExcludeMinimumConsumption: boolean;
  setXdExcludeMinimumConsumption: React.Dispatch<React.SetStateAction<boolean>>;

  xdBook: boolean;
  setXdBook: React.Dispatch<React.SetStateAction<boolean>>;

  setXdPrinters: React.Dispatch<React.SetStateAction<string>>;
  nomeCategoria: string;
  setNomeCategoria: React.Dispatch<React.SetStateAction<string>>;
  image: string;
  setImage: React.Dispatch<React.SetStateAction<string>>;
  complemento: number;
  setComplemento: React.Dispatch<React.SetStateAction<number>>;
  nomeSubcategoria: number;
  setNomeSubcategoria: React.Dispatch<React.SetStateAction<number>>;
  order: number;
  setOrder: React.Dispatch<React.SetStateAction<number>>;
  idPDV: number;
  setIdPDV: React.Dispatch<React.SetStateAction<number>>;
  perfilFiscal: number;
  setPerfilFiscal: React.Dispatch<React.SetStateAction<number>>;
  complementList: any[];
  setComplementList: React.Dispatch<React.SetStateAction<any[]>>;
  listaPerfilFiscal: any[];
  setListaPerfilFiscal: React.Dispatch<React.SetStateAction<any[]>>;
  listaSubCategoria: any[];
  setListaSubCategoria: React.Dispatch<React.SetStateAction<any[]>>;
  dataSheetList: any[];
  setDataSheetList: React.Dispatch<React.SetStateAction<any[]>>;
  nomeCategoriaInValid: boolean;
  setNomeCategoriaInValid: React.Dispatch<React.SetStateAction<boolean>>;
  nomelistaSubCategoriaInValid: boolean;
  setNomelistaSubCategoriaInValid: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  nomelistalistaPerfilFiscalInValid: boolean;
  setNomelistalistaPerfilFiscalInValid: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setAssociatedComplement: React.Dispatch<React.SetStateAction<any[]>>;
  associatedComplement: any;
  clearFilds: () => void;
  handleValidete: () => boolean;
  handleEdit: (props: ICategories) => void;

  categoriesList: any;
  setCategoriesComplement: React.Dispatch<React.SetStateAction<any[]>>;
  category?: number;
  setCategory: React.Dispatch<React.SetStateAction<number | undefined>>;
  status: boolean;
  setStatus: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CategoryContext = createContext<InitialContextInterface>(
  {} as InitialContextInterface
);

export const CategoryProvider = ({ children }: ChildrenProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [status, setStatus] = useState<boolean>(true);

  const [xdFollowItem, setXdFollowItem] = useState<boolean>(false);
  const [selfService, setSelfService] = useState<boolean>(false);
  const [visible_falimix, setVisible_falimix] = useState<boolean>(true);
  const [visible_autoplu, setVisible_autoplu] = useState<boolean>(true);
  const [visible_delivery, setVisible_delivery] = useState<boolean>(true);
  const [visible_xd_orders, setVisible_xd_orders] = useState<boolean>(true);
  const [visible_online, setVisible_online] = useState<boolean>(true);
  const [visible_digital_menu, setVisible_digital_menu] =
    useState<boolean>(true);

  const [xdPrinters, setXdPrinters] = useState<string>(
    '0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0'
  );
  //Informações de venda
  const [xdRequestQty, setXdRequestQty] = useState<boolean>(false);
  const [xdRequestPriceWhenZero, setXdRequestPriceWhenZero] =
    useState<boolean>(true);
  const [xdBalanceQty, setXdBalanceQty] = useState<boolean>(false);
  const [xdOrderGrouped, setXdOrderGrouped] = useState<boolean>(true);
  const [xdBillGroup, setXdBillGroup] = useState<boolean>(true);
  const [xdAddTips, setXdAddTips] = useState<boolean>(true);
  const [xdExcludeMinimumConsumption, setXdExcludeMinimumConsumption] =
    useState<boolean>(false);
  const [xdBook, setXdBook] = useState<boolean>(false);

  const [nomeCategoria, setNomeCategoria] = useState<string>('');
  const [complemento, setComplemento] = useState<number>(0);
  const [order, setOrder] = useState<number>(0);
  const [nomeSubcategoria, setNomeSubcategoria] = useState<number>(0);
  const [perfilFiscal, setPerfilFiscal] = useState<number>(0);
  const [idPDV, setIdPDV] = useState<number>(0);

  const [complementList, setComplementList] = useState<Array<any>>([]);
  const [listaPerfilFiscal, setListaPerfilFiscal] = useState<any[]>([]);
  const [listaSubCategoria, setListaSubCategoria] = useState<any[]>([]);
  const [dataSheetList, setDataSheetList] = useState<any[]>([]);
  const [image, setImage] = useState('');

  const [category, setCategory] = useState<number | undefined>(undefined);
  const [categoriesList, setCategoriesComplement] = useState<Array<any>>([]);
  const [associatedComplement, setAssociatedComplement] = useState<Array<any>>(
    []
  );
  const [nomeCategoriaInValid, setNomeCategoriaInValid] =
    useState<boolean>(false);
  const [nomelistaSubCategoriaInValid, setNomelistaSubCategoriaInValid] =
    useState<boolean>(false);
  const [
    nomelistalistaPerfilFiscalInValid,
    setNomelistalistaPerfilFiscalInValid,
  ] = useState<boolean>(false);

  const handleValidete = () => {
    if (!nomeCategoria) setNomeCategoriaInValid(true);
    if (nomeCategoria) setNomeCategoriaInValid(false);
    if (!perfilFiscal) setNomelistalistaPerfilFiscalInValid(true);
    if (perfilFiscal) setNomelistalistaPerfilFiscalInValid(false);

    if (nomeCategoria && perfilFiscal) {
      return true;
    }

    return false;
  };

  const clearFilds = () => {
    setStatus(true);
    setXdFollowItem(false);
    setXdPrinters('0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0');
    setNomeCategoria('');
    setComplemento(0);
    setNomeSubcategoria(0);
    setPerfilFiscal(0);
    setDataSheetList([]);
    setOrder(0);
    setImage('');
    setCategoriesComplement([]);
    setAssociatedComplement([]);

    setXdRequestQty(false);
    setXdRequestPriceWhenZero(true);
    setXdBalanceQty(false);
    setXdOrderGrouped(true);
    setXdBillGroup(true);
    setXdAddTips(true);
    setXdExcludeMinimumConsumption(false);
    setXdBook(false);
    setXdFollowItem(false);
    setXdPrinters('0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0');
    setVisible_falimix(true);
    setVisible_autoplu(true);
    setVisible_delivery(true);
    setVisible_xd_orders(true);
    setVisible_online(true);
    setVisible_digital_menu(true);
  };

  const handleEdit = async (props: any) => {
    const categorie: ICategories = props;

    setStatus(categorie?.is_active);
    setXdFollowItem(categorie.xd_follow_item);
    setXdPrinters(categorie.xd_printers);
    setNomeCategoria(categorie.name);
    setOrder(categorie?.sort_category);
    //setComplemento(categorie.relationships?.complements);
    setNomeSubcategoria(categorie.parent_id);
    setPerfilFiscal(categorie.tax_profile_id);
    setDataSheetList(categorie.relationships?.complements ?? []);
    setSelfService(categorie?.self_service);
    setImage(categorie?.image);
    setVisible_falimix(categorie?.visible_falimix);
    setVisible_autoplu(categorie?.visible_autoplu);
    setVisible_delivery(categorie?.visible_delivery);
    setVisible_xd_orders(categorie?.visible_xd_orders);
    setVisible_online(categorie?.visible_online);
    setVisible_digital_menu(categorie?.visible_digital_menu);
    setXdRequestQty(categorie?.xd_request_qty);
    setXdRequestPriceWhenZero(categorie?.xd_request_price_when_zero);
    setXdBalanceQty(categorie?.xd_balance_qty);
    setXdOrderGrouped(categorie?.xd_order_grouped);
    setXdBillGroup(categorie?.xd_bill_group);
    setXdAddTips(categorie?.xd_add_tips);
    setXdExcludeMinimumConsumption(categorie?.xd_exclude_minimum_consumption);
    setXdBook(categorie?.xd_book);
    setCategoriesComplement(categorie.relationships.complements);
    setAssociatedComplement(categorie.relationships?.product_associateds);
  };

  useEffect(() => {
    if (nomeCategoria) setNomeCategoriaInValid(false);
    if (nomeSubcategoria) setNomelistaSubCategoriaInValid(false);
    if (perfilFiscal) setNomelistalistaPerfilFiscalInValid(false);
  }, [nomeCategoria, nomeSubcategoria, perfilFiscal]);

  return (
    <CategoryContext.Provider
      value={{
        loading,
        setLoading,
        xdFollowItem,
        setXdFollowItem,
        xdPrinters,
        setXdPrinters,
        nomeCategoria,
        setNomeCategoria,
        complemento,
        setComplemento,
        nomeSubcategoria,
        setNomeSubcategoria,
        perfilFiscal,
        setPerfilFiscal,
        complementList,
        setComplementList,
        listaPerfilFiscal,
        setListaPerfilFiscal,
        listaSubCategoria,
        setListaSubCategoria,
        dataSheetList,
        setDataSheetList,
        nomeCategoriaInValid,
        setNomeCategoriaInValid,
        nomelistaSubCategoriaInValid,
        setNomelistaSubCategoriaInValid,
        nomelistalistaPerfilFiscalInValid,
        setNomelistalistaPerfilFiscalInValid,
        clearFilds,
        handleValidete,
        handleEdit,
        setSelfService,
        selfService,
        image,
        setImage,
        idPDV,
        setIdPDV,
        order,
        setOrder,
        visible_falimix,
        setVisible_falimix,
        visible_autoplu,
        setVisible_autoplu,
        visible_delivery,
        setVisible_delivery,
        visible_xd_orders,
        setVisible_xd_orders,
        visible_online,
        setVisible_online,
        visible_digital_menu,
        setVisible_digital_menu,
        xdRequestQty,
        setXdRequestQty,
        xdRequestPriceWhenZero,
        setXdRequestPriceWhenZero,
        xdBalanceQty,
        setXdBalanceQty,
        xdOrderGrouped,
        setXdOrderGrouped,
        xdBillGroup,
        setXdBillGroup,
        xdAddTips,
        setXdAddTips,
        xdExcludeMinimumConsumption,
        setXdExcludeMinimumConsumption,
        xdBook,
        setXdBook,
        categoriesList,

        setCategoriesComplement,
        setCategory,
        category,
        associatedComplement,
        setAssociatedComplement,
        status,
        setStatus,
      }}
    >
      {children}
    </CategoryContext.Provider>
  );
};
